import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "../../components/Component";

const PaymentsAside = ({ updateSm, sm }: any) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  const flowType = searchParams.get("flowType");
  const flowTypeQuery = flowType ? `?flowType=${flowType}` : "";

  const isActive = (path: string) => {
    return currentPath.includes(path);
  };

  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          <div className="user-info">
            <span className="lead-text">Payments</span>
            <span className="sub-text">
              Manage payment creation, approvals, processing, and tracking
            </span>
          </div>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li className={isActive("/create-payment") ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/create-payment`}
              onClick={() => updateSm(false)}
            >
              <Icon name="plus-circle" />
              <span>Create Payment</span>
            </Link>
          </li>
          <li className={isActive("/view-payments") ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/view-payments${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="list" />
              <span>View Payments</span>
            </Link>
          </li>
          <li
            className={isActive("/pending-payment-approvals") ? "active" : ""}
          >
            <Link
              to={`${process.env.PUBLIC_URL}/pending-payment-approvals`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-round" />
              <span>Pending Approvals</span>
            </Link>
          </li>
          <li className={isActive("/release-retention") ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/release-retention`}
              onClick={() => updateSm(false)}
            >
              <Icon name="unlock" />
              <span>Release Retention</span>
            </Link>
          </li>
          <li className={isActive("/release-on-hold") ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/release-on-hold`}
              onClick={() => updateSm(false)}
            >
              <Icon name="shield-off" />
              <span>Release On Hold</span>
            </Link>
          </li>
          {/* <li>
            <Link
              to={`${process.env.PUBLIC_URL}/invoice-payables`}
              onClick={() => updateSm(false)}
            >
              <Icon name="file-text" />
              <span>Invoice Payables</span>
            </Link>
          </li> */}

          {/* <li>
            <Link
              to={`${process.env.PUBLIC_URL}/run-payments`}
              onClick={() => updateSm(false)}
            >
              <Icon name="play" />
              <span>Run Payments</span>
            </Link>
          </li> */}
          {/* <li>
            <Link
              to={`${process.env.PUBLIC_URL}/payment-analytics`}
              onClick={() => updateSm(false)}
            >
              <Icon name="growth" />
              <span>Analytics</span>
            </Link>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default PaymentsAside;
